// PARAQTA — Марафон квизі (Stage 10). Синхронды: 20 сұрақ × 20 сек, бір рет.
// Анти-чит толықтай серверде (таймер, ұпай, нұсқа реті). Бұл — тек UI.
import { shareCertificate } from '../marathon-card/index.js';

const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
}[c]));

async function jget(url) {
  const r = await fetch(url, { credentials: 'same-origin' });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || 'Қате');
  return d;
}
async function jpost(url, body) {
  const r = await fetch(url, {
    method: 'POST',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || 'Қате');
  return d;
}

let _timer = null;
let _cur = null;
let _deadline = 0;
let _locked = false;

function clearTimer() { if (_timer) { clearInterval(_timer); _timer = null; } }

// ─── Марафон бетіндегі квиз картасы ───
export async function injectQuizCard(pageNode) {
  let st;
  try { st = await jget('/api/marathon/quiz/state'); } catch { return; }
  if (!st || !st.available || !st.can_play) return;
  const html = quizCardHtml(st);
  if (!html) return;
  const card = document.createElement('section');
  card.className = 'mr-section';
  card.innerHTML = html;
  const cta = pageNode.querySelector('.mr-cta-wrap');
  if (cta && cta.parentNode) cta.parentNode.insertBefore(card, cta);
  else pageNode.querySelector('.mr-page')?.appendChild(card);
  const btn = card.querySelector('[data-quiz-act]');
  if (btn) btn.addEventListener('click', () => {
    const act = btn.getAttribute('data-quiz-act');
    if (act === 'play') openQuiz();
    else if (act === 'result') showQuizResult();
  });
  if (st.phase === 'before' && st.open_ts) startCardCountdown(card, st);
}

function quizCardHtml(st) {
  const eye = '<div class="mr-eyebrow">КВИЗ — ЧЕМПИОНДЫ АНЫҚТАЙДЫ</div>';
  // Админге — ашылуын күтпей тест жасауға (фаза open емес, әлі тапсырмаған).
  const adminBtn = (st.is_admin && st.phase !== 'open' && !st.finished)
    ? `<button class="mr-cta-btn mr-cta-tg" data-quiz-act="play" style="margin-top:10px"><i class="ti ti-tool"></i> Квизді тест (админ)</button>`
    : '';
  if (st.finished) {
    return eye + `<div class="mr-card mr-quiz-card">
      <div class="mr-quiz-ttl">Квиз тапсырылды ✓</div>
      <div class="mr-quiz-sub">Ұпай: <b>${st.my_score ?? 0}/${st.num_q}</b></div>
      <button class="mr-cta-btn" data-quiz-act="result" style="margin-top:12px">Нәтиже / рейтинг</button>
    </div>`;
  }
  if (st.phase === 'before') {
    return eye + `<div class="mr-card mr-quiz-card">
      <div class="mr-quiz-ttl">Квиз жуырда</div>
      <div class="mr-quiz-sub">${st.num_q} сұрақ · әрқайсысына ${st.sec_q} секунд</div>
      <div class="mr-quiz-count" data-quiz-count>—</div>
      <div class="mr-quiz-hint">Кешікпе — басталғанда бәрі бірге жарысады</div>
      ${adminBtn}
    </div>`;
  }
  if (st.phase === 'open') {
    return eye + `<div class="mr-card mr-quiz-card mr-quiz-live">
      <div class="mr-quiz-ttl">Квиз ашық! 🔥</div>
      <div class="mr-quiz-sub">${st.num_q} сұрақ · ${st.sec_q} сек · бір рет қана</div>
      <button class="mr-cta-btn" data-quiz-act="play" style="margin-top:12px"><i class="ti ti-player-play"></i> Квизге кіру</button>
    </div>`;
  }
  if (st.phase === 'closed') {
    return eye + `<div class="mr-card mr-quiz-card">
      <div class="mr-quiz-ttl">Квиз аяқталды</div>
      <button class="mr-cta-btn" data-quiz-act="result" style="margin-top:12px">Нәтиже / рейтинг</button>
      ${adminBtn}
    </div>`;
  }
  return '';
}

function startCardCountdown(card, st) {
  const el = card.querySelector('[data-quiz-count]');
  if (!el) return;
  const offset = Date.now() / 1000 - st.server_ts; // client - server
  const iv = setInterval(tick, 1000);
  tick();
  function tick() {
    const nowS = Date.now() / 1000 - offset;
    const left = st.open_ts - nowS;
    if (left <= 0) { el.textContent = 'Басталды!'; clearInterval(iv); return; }
    const d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600),
      m = Math.floor((left % 3600) / 60), s = Math.floor(left % 60);
    el.textContent = d > 0 ? `${d} күн ${h} сағ` :
      `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
}

// ─── Квиз overlay ───
function overlay() {
  let ov = document.getElementById('mrQuizOv');
  if (!ov) { ov = document.createElement('div'); ov.id = 'mrQuizOv'; ov.className = 'mq-ov'; document.body.appendChild(ov); }
  return ov;
}
function closeQuiz() { clearTimer(); document.getElementById('mrQuizOv')?.remove(); }

export async function openQuiz() {
  const ov = overlay();
  ov.innerHTML = '<div class="mq-box"><div class="mq-loading">Дайындалуда…</div></div>';
  let data;
  try { data = await jpost('/api/marathon/quiz/start'); }
  catch (e) {
    ov.innerHTML = `<div class="mq-box"><div class="mq-err">${esc(e?.message || 'Қате')}</div><button class="mr-cta-btn" id="mqClose">Жабу</button></div>`;
    ov.querySelector('#mqClose').onclick = closeQuiz;
    return;
  }
  if (data.done) { renderQuizDone(data); return; }
  renderQuestion(data.question);
}

function renderQuestion(q) {
  if (!q) { closeQuiz(); return; }
  _cur = q; _locked = false;
  const ov = overlay();
  ov.innerHTML = `
    <div class="mq-box">
      <div class="mq-top">
        <div class="mq-prog">${q.ord} / ${q.num_q}</div>
        <div class="mq-timer">
          <svg viewBox="0 0 36 36"><circle class="mq-ring-bg" cx="18" cy="18" r="16"></circle><circle class="mq-ring" cx="18" cy="18" r="16" data-ring></circle></svg>
          <span data-secs>${q.remaining}</span>
        </div>
      </div>
      <div class="mq-q">${esc(q.text)}</div>
      <div class="mq-opts">
        ${q.options.map((o, i) => `<button class="mq-opt" data-i="${i}">${esc(o)}</button>`).join('')}
      </div>
    </div>`;
  ov.querySelectorAll('.mq-opt').forEach(b =>
    b.addEventListener('click', () => submitAnswer(parseInt(b.dataset.i, 10))));
  startQTimer(q.remaining, q.sec_q || 20);
}

function startQTimer(remaining, secq) {
  clearTimer();
  _deadline = Date.now() + remaining * 1000;
  const ov = overlay();
  const secsEl = ov.querySelector('[data-secs]');
  const ring = ov.querySelector('[data-ring]');
  const circ = 2 * Math.PI * 16;
  if (ring) ring.style.strokeDasharray = String(circ);
  const upd = () => {
    const left = (_deadline - Date.now()) / 1000;
    if (secsEl) secsEl.textContent = String(Math.max(0, Math.ceil(left)));
    if (ring) ring.style.strokeDashoffset = String(circ * (1 - Math.max(0, left) / secq));
    if (left <= 3 && secsEl) secsEl.classList.add('mq-low');
    if (left <= 0) { clearTimer(); if (!_locked) submitAnswer(null); }
  };
  upd();
  _timer = setInterval(upd, 100);
}

async function submitAnswer(choiceIndex) {
  if (_locked) return;
  _locked = true; clearTimer();
  const ov = overlay();
  ov.querySelectorAll('.mq-opt').forEach(b => b.classList.add('mq-disabled'));
  if (choiceIndex !== null) ov.querySelector(`.mq-opt[data-i="${choiceIndex}"]`)?.classList.add('mq-picked');
  let data;
  try { data = await jpost('/api/marathon/quiz/answer', { ord: _cur.ord, choice: choiceIndex }); }
  catch { _locked = false; return; }
  const fb = data.feedback;
  if (fb && typeof fb.correct_shown === 'number')
    ov.querySelector(`.mq-opt[data-i="${fb.correct_shown}"]`)?.classList.add('mq-correct');
  if (choiceIndex !== null && fb && !fb.was_correct)
    ov.querySelector(`.mq-opt[data-i="${choiceIndex}"]`)?.classList.add('mq-wrong');
  setTimeout(() => {
    if (data.done) renderQuizDone(data);
    else renderQuestion(data.question);
  }, 850);
}

function renderQuizDone(data) {
  clearTimer();
  const ov = overlay();
  ov.innerHTML = `
    <div class="mq-box mq-done">
      <div class="mq-done-ic">🎉</div>
      <div class="mq-done-ttl">Квиз бітті!</div>
      <div class="mq-done-score">${data.score ?? 0}<span>/${data.num_q}</span></div>
      <div class="mq-done-sub">дұрыс жауап</div>
      <button class="mr-cta-btn mr-cta-share" id="mqCert" style="margin-top:18px"><i class="ti ti-certificate"></i> Сертификат алу</button>
      <button class="mr-cta-btn" id="mqResult" style="margin-top:10px">Рейтингті көру</button>
      <button class="mq-link" id="mqClose2">Жабу</button>
    </div>`;
  ov.querySelector('#mqCert').onclick = () => certClick(data.score, data.num_q);
  ov.querySelector('#mqResult').onclick = showQuizResult;
  ov.querySelector('#mqClose2').onclick = closeQuiz;
}

async function certClick(score, num_q) {
  let cur = {};
  try { cur = (await jget('/api/marathon/current')).marathon || {}; } catch {}
  await shareCertificate({ name: cur.my_name, number: cur.my_number, score, num_q });
}

export async function showQuizResult() {
  const ov = overlay();
  ov.innerHTML = '<div class="mq-box"><div class="mq-loading">Жүктелуде…</div></div>';
  let data;
  try { data = await jget('/api/marathon/quiz/result'); }
  catch { closeQuiz(); return; }
  const lb = data.leaderboard || [];
  const lbHtml = lb.length
    ? `<div class="mq-lb">${lb.map(r => `
        <div class="mq-lb-row${r.is_me ? ' me' : ''}">
          <span class="mq-lb-rank">${r.rank}</span>
          <span class="mq-lb-name">${esc(r.name)}</span>
          <span class="mq-lb-score">${r.score}</span>
        </div>`).join('')}</div>`
    : `<div class="mq-done-sub" style="margin-top:14px">${data.closed ? 'Әзірге нәтиже жоқ' : 'Рейтинг квиз жабылғанда шығады'}</div>`;
  ov.innerHTML = `
    <div class="mq-box">
      <button class="mq-x" id="mqX" aria-label="Жабу">✕</button>
      <div class="mq-done-ttl">Сенің нәтижең</div>
      <div class="mq-done-score">${data.score ?? 0}<span>/${data.num_q}</span></div>
      ${data.my_rank ? `<div class="mq-done-sub">Жалпы орның: <b>#${data.my_rank}</b></div>` : ''}
      ${data.my_cohort_rank ? `<div class="mq-done-sub">Жас тобыңда (${esc(data.my_band)}): <b>#${data.my_cohort_rank}</b></div>` : ''}
      <button class="mr-cta-btn mr-cta-share" id="mqCert2" style="margin-top:14px"><i class="ti ti-certificate"></i> Сертификат алу</button>
      ${lbHtml}
    </div>`;
  ov.querySelector('#mqX').onclick = closeQuiz;
  ov.querySelector('#mqCert2').onclick = () => certClick(data.score, data.num_q);
}
